require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./hsa-hub-service-agreement.json") })
        }
      }, "path---hsa-hub-service-agreement");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---hsa-hub-service-agreement!./.cache/json/hsa-hub-service-agreement.json
// module id = 2644
// module chunks = 231608221292675